import React from 'react';
import ValidatedDecimalInput from '../../../components/ValidatedDecimalInput/ValidatedDecimalInput';
import EditableTextField from './EditableTextField';
import EditableSelectField from './EditableSelectField';

export default function VentilationHeatingCoolingTab({ project, editable, handleInputChange, handleFieldValidityChange }) {
  return (
    <table className='project-detail-table'>
      <tbody>
        <tr>
          <td>Ventilation System Manufacturer</td>
          <td>
            <EditableTextField
              name='ventilation_system_manufacturer'
              value={project.ventilation_system_manufacturer}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          <td>Ventilation Product Name</td>
          <td>
            <EditableTextField
              name='ventilation_system_product_name'
              value={project.ventilation_system_product_name}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Ventilation System Type</td>
          <td>
            {/* ERV, HRV, Multifunction, Other */}
            <EditableSelectField
              name='ventilation_system_type'
              value={project.ventilation_system_type}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['ERV', 'HRV', 'Multifunction', 'Other']}
            />
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Sensible Recovery Efficiency</td>
          <td>
            <ValidatedDecimalInput
              name='sensible_recovery_efficiency'
              value={project.sensible_recovery_efficiency}
              onChange={(e) => handleInputChange(e)}
              editable={editable === true}
              unit='%'
              onValidityChange={handleFieldValidityChange}
            />
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Latent Recovery Efficiency</td>
          <td>
            <ValidatedDecimalInput
              name='latent_recovery_efficiency'
              value={project.latent_recovery_efficiency}
              onChange={(e) => handleInputChange(e)}
              editable={editable === true}
              unit='%'
              onValidityChange={handleFieldValidityChange}
            />
          </td>
        </tr>
        {/* measured fan effcienct: number */}
        <tr>
          {/* picklist */}
          <td>Ventilation System Layout</td>
          <td>
            <EditableSelectField
              name='ventilation_system_layout'
              value={project.ventilation_system_layout}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['Centralized', 'Semi-Centralized', 'De-Centralized']}
            />
          </td>
        </tr>
        <tr>
          <td>Heating System Manufacturer</td>
          <td>
            <EditableTextField
              name='heating_system_manufacturer'
              value={project.heating_system_manufacturer}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          <td>Heating System Product Name</td>
          <td>
            <EditableTextField
              name='heating_system_product_name'
              value={project.heating_system_product_name}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Heating System Type</td>
          <td>
            <EditableSelectField
              name='heating_system_type'
              value={project.heating_system_type}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={[
                'Air Source Heat Pump',
                'Variable Refrigerant Flow (VRF)',
                'Furnace',
                'Boiler',
                'Wood Stove',
                'Pellet Stove',
                'Ground Source Heat Pump',
                'Water Source Heat Pump',
              ]}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Heating System Rating</td>
          <td>
            <EditableSelectField
              name='heating_system_rating'
              value={project.heating_system_rating}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['% Efficiency', 'COP']}
            />
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Heating System Performance Efficiency</td>
          <td>
            <ValidatedDecimalInput
              name='heating_system_performance_efficiency'
              value={project.heating_system_performance_efficiency}
              onChange={(e) => handleInputChange(e)}
              editable={editable === true}
              unit='%'
              onValidityChange={handleFieldValidityChange}
            />
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Heating System Performance (COP)</td>
          <td>
            <ValidatedDecimalInput
              name='heating_system_performance_COP'
              value={project.heating_system_performance_COP}
              onChange={(e) => handleInputChange(e)}
              editable={editable === true}
              onValidityChange={handleFieldValidityChange}
            />
          </td>
        </tr>
        <tr>
          <td>Cooling System Manufacturer</td>
          <td>
            <EditableTextField
              name='cooling_system_manufacturer'
              value={project.cooling_system_manufacturer}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          <td>Cooling System Product Name</td>
          <td>
            <EditableTextField
              name='cooling_system_product_name'
              value={project.cooling_system_product_name}
              onChange={handleInputChange}
              editable={editable === true}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Cooling System Type</td>
          <td>
            {/* Air Source Heat Pump, Variable Refrigerant Flow (VRF), Ground Source Heat Pump, Water Source Heat Pump */}
            <EditableSelectField
              name='cooling_system_type'
              value={project.cooling_system_type}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={[
                'Air Source Heat Pump',
                'Variable Refrigerant Flow (VRF)',
                'Ground Source Heat Pump',
                'Water Source Heat Pump',
              ]}
            />
          </td>
        </tr>
        <tr>
          {/* picklist */}
          <td>Cooling System Rating</td>
          <td>
            <EditableSelectField
              name='cooling_system_rating'
              value={project.cooling_system_rating}
              onChange={handleInputChange}
              editable={editable === true}
              disabledFallback='text'
              options={['IEER', 'EER']}
            />
          </td>
        </tr>
        {/* Cooling System Performance (IEER/EER): not folded — the disabled branch is
            missing type='number' (present only in the editable branch, same asymmetry
            as Total Project Cost above), and both branches wrap the value in
            Math.floor(...), truncating any fractional rating for display only (the
            real stored value is untouched unless the user edits the field). Low real-
            world impact (EER/IEER ratings are conventionally whole numbers already),
            left hand-written rather than silently changing the type-attribute
            asymmetry or dropping the floor(). */}
        <tr>
          {/* number */}
          <td>Cooling System Performance (IEER)</td>
          <td>
            {editable === true ? (
              <input
                type='number'
                name='cooling_system_performance_IEER'
                onChange={(e) => handleInputChange(e)}
                className='edit-input'
                value={Math.floor(
                  project.cooling_system_performance_IEER
                )}
              />
            ) : (
              <input
                name='cooling_system_performance_IEER'
                onChange={(e) => handleInputChange(e)}
                className='project-detail-input'
                disabled
                value={Math.floor(
                  project.cooling_system_performance_IEER
                )}
              />
            )}
          </td>
        </tr>
        <tr>
          {/* number */}
          <td>Cooling System Performance (EER)</td>
          <td>
            {editable === true ? (
              <input
                type='number'
                name='cooling_system_performance_EER'
                onChange={(e) => handleInputChange(e)}
                className='edit-input'
                value={Math.floor(project.cooling_system_performance_EER)}
              />
            ) : (
              <input
                name='cooling_system_performance_EER'
                onChange={(e) => handleInputChange(e)}
                className='project-detail-input'
                disabled
                value={Math.floor(project.cooling_system_performance_EER)}
              />
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
